import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { Capacitor } from '@capacitor/core';
import { SocialLogin } from '@capgo/capacitor-social-login';
import { environment } from './environments/environment';

// Initialize SocialLogin for web
if (!Capacitor.isNativePlatform()) {
  SocialLogin.initialize({
    google: {
      webClientId: environment.googleClientId,
    },
  });
}

bootstrapApplication(AppComponent, appConfig);
